<template>
  <div class="new-cash-float-open" data-cy="cash-float-open-modal">
    <div
      v-if="!isGeneralCashfloat && !isDetailedCashfloat"
      style="
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding-left: 15%;
        padding-right: 15%;
        height: 85%;
      "
    >
      <div style="width: 100%; text-align: center; height: fit-content">
        <p style="font-size: 35px; margin-bottom: 1%">
          <strong>Opening Sales</strong>
        </p>
        <p style="font-size: 30px">
          {{
            String(t("cashfloat.please-process")).replace("xxx", userFirstName)
          }}
        </p>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          flex-wrap: wrap;
          height: 70%;
          margin-top: 2%;
        "
      >
        <div
          @click="toggleCashfloatType(CashfloatType.General)"
          style="
            width: 25%;
            height: 80%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid gray;
            border-radius: 5px;
            padding: 5%;
            padding-top: 0%;
            margin: 5%;
            margin-top: 2%;
          "
          data-cy="general-cashfloat-button"
        >
          <p style="margin-bottom: 7%">{{ t("cashfloat.total-cashfloat") }}</p>
          <div
            style="
              height: 180px;
              width: 180px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              style="max-width: 80%; height: auto"
              src="@/assets/images/icons/total_cashfloat_icon.png"
              alt="total cashfloat"
            />
          </div>
        </div>
        <div
          @click="toggleCashfloatType(CashfloatType.Detailed)"
          style="
            width: 25%;
            height: 80%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid gray;
            border-radius: 5px;
            padding: 5%;
            padding-top: 0%;
            margin: 5%;
            margin-top: 2%;
          "
          data-cy="detailed-cashfloat-button"
        >
          <p style="margin-bottom: 7%">{{ t("cashfloat.individual-cash") }}</p>
          <div
            style="
              height: 180px;
              width: 180px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              style="max-width: 100%; height: auto"
              src="@/assets/images/icons/detailed_cashfloat_icon.png"
              alt="detailed cashfloat"
            />
          </div>
        </div>
        <!-- :: -->
        <div
          v-if="!isGeneralCashfloat && !isDetailedCashfloat"
          style="
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            padding-top: 5px;
            width: 60%;
          "
        >
          <SButton type="button" variant="outline" size="sm" @click="cancel">
            {{ $t("button.cancel") }}
          </SButton>
        </div>
        <!-- :: -->
      </div>
    </div>

    <div
      v-if="isGeneralCashfloat && !hasPreviousCashfloatMoney"
      class="general-cashfloat"
      style="
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-self: center;
        width: 100%;
        max-width: 32rem;
        margin-top: 10%;
      "
    >
      <div style="text-align: center; margin-bottom: 10%">
        <p style="font-size: 30px">
          <strong>{{ t("cashfloat.summarized-cash") }}</strong>
        </p>
      </div>
      <div
        style="display: flex; flex-direction: column; justify-content: center"
      >
        <div style="margin-bottom: 10px">
          <SInputGroup>
            <SInputGroupAddon align="inline-start">
              <SInputGroupText class="w-24 pl-3">{{
                groupCurrency
              }}</SInputGroupText>
            </SInputGroupAddon>
            <SInputGroupInput
              class="h-[3.25rem] text-base"
              data-cy="cashfloat-amount-input"
              :model-value="totalByCurrency[groupCurrency]"
              @update:model-value="(v) => (totalByCurrency[groupCurrency] = v)"
              @change="(e) => adjustAmount((e.target as HTMLInputElement).value, groupCurrency)"
              placeholder="Add total"
              type="number"
              :min="0"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
            />
          </SInputGroup>
        </div>
        <div
          v-for="(currencyLabel, index) in addedCurrencies"
          :key="currencyLabel"
          style="margin-bottom: 10px"
        >
          <SInputGroup>
            <SInputGroupAddon align="inline-start" class="has-[>button]:ml-0">
              <SSelect
                :model-value="addedCurrencies[index]"
                @update:model-value="(v) => { addedCurrencies[index] = v as string; currencySelectChanged(v as string, currencyLabel); }"
              >
                <SSelectTrigger
                  class="h-[3.25rem] w-24 rounded-none border-0 bg-transparent text-base shadow-none focus:ring-0 focus-visible:ring-0"
                >
                  <SSelectValue />
                </SSelectTrigger>
                <SSelectContent>
                  <SSelectItem :value="currencyLabel">{{
                    currencyLabel
                  }}</SSelectItem>
                  <SSelectItem
                    v-for="item in notAddedCurrencies"
                    :key="item.id"
                    :value="item.label"
                  >
                    {{ item.label }}
                  </SSelectItem>
                </SSelectContent>
              </SSelect>
            </SInputGroupAddon>
            <SInputGroupInput
              class="h-[3.25rem] text-base"
              data-cy="cashfloat-amount-input"
              :model-value="totalByCurrency[currencyLabel]"
              @update:model-value="(v) => (totalByCurrency[currencyLabel] = v)"
              @change="(e) => adjustAmount((e.target as HTMLInputElement).value, currencyLabel)"
              placeholder="Add total"
              type="number"
              :min="0"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
            />
            <SInputGroupAddon align="inline-end">
              <button
                @click="removeAddedCurrency(currencyLabel)"
                class="remove-currency-btn"
              >
                X
              </button>
            </SInputGroupAddon>
          </SInputGroup>
        </div>

        <div
          style="text-align: center; margin-bottom: 5px; margin-top: 5%"
          v-if="hasLocation"
        >
          <p style="font-size: 20px">Cash taken from:</p>
        </div>

        <div style="margin-bottom: 10px; width: 100%" v-if="hasLocation">
          <SSelect v-model="locationId">
            <SSelectTrigger
              class="w-full"
              :disabled="isMoneyAlreadyInDrawer || allGeneralAmountsAreZero"
              data-cy="location-select"
            >
              <SSelectValue :placeholder="$t('location')" />
            </SSelectTrigger>
            <SSelectContent>
              <SSelectItem
                v-for="item in locationsList"
                :key="Number(item.id)"
                :value="Number(item.id)"
                data-cy="location-option"
              >
                {{ String(item.name) }}
              </SSelectItem>
            </SSelectContent>
          </SSelect>
        </div>
        <div style="margin-bottom: 10px" v-if="hasLocation">
          <label class="flex items-center gap-2">
            <SCheckbox
              :model-value="isMoneyAlreadyInDrawer"
              @update:model-value="
                (v) => {
                  isMoneyAlreadyInDrawer = Boolean(v);
                  resetLocationId();
                }
              "
              :disabled="!hasPreviousCashfloatMoney || allGeneralAmountsAreZero"
            />
            <span>{{ $t("cashfloat.money-already-in-the-drawer") }}</span>
          </label>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <SButton
          v-if="notAddedCurrencies.length && hasMultiCurrenciesEnabled"
          type="button"
          variant="outline"
          size="sm"
          data-cy="add-currency-button"
          @click="addCurrency"
        >
          {{ $t("multicurrencies.add-currency") }}
        </SButton>
      </div>
      <div class="cashfloat-actions">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="w-full h-16 text-base"
          :disabled="submitingCashFloat"
          data-cy="cancel-button"
          @click="cancel"
        >
          {{ $t("button.cancel") }}
        </SButton>
        <SButton
          type="button"
          size="lg"
          class="w-full h-16 text-base"
          :style="{
            visibility: canConfirmGeneralCashfloat ? 'visible' : 'hidden',
          }"
          :loading="submitingCashFloat"
          data-cy="confirm-button"
          @click="submitGeneralCashfloat"
        >
          {{ $t("button.confirm") }}
        </SButton>
      </div>
    </div>
    <!-- :: -->
    <!-- Previous cashfloat amount wasn't cashed out: the drawer already holds money -->
    <div
      v-if="isGeneralCashfloat && hasPreviousCashfloatMoney"
      class="general-cashfloat flex w-full max-w-lg flex-col self-center pt-[6%]"
    >
      <h2 class="mb-10 text-center text-3xl font-bold">
        {{ t("cashfloat.summarized-cash") }}
      </h2>
      <div class="flex flex-col gap-5">
        <div v-for="currency in currencies" :key="currency.id">
          <p class="mb-1.5 text-[13px] font-medium text-muted-foreground">
            {{ t("cashfloat.initial-cashfloat") }}
          </p>
          <SInputGroup>
            <SInputGroupInput
              class="h-[3.25rem] text-base font-semibold"
              disabled
              :model-value="previousCashfloatAmounts[currency.label as Currencies]"
              @update:model-value="(v) => (previousCashfloatAmounts[currency.label as Currencies] = v)"
              placeholder="Add total"
              type="number"
              :min="0"
              @focus="handleInputFocus"
              @blur="handleInputBlur"
              data-cy="existing-cashfloat-amount-input"
            />
            <SInputGroupAddon align="inline-end">
              <SInputGroupText class="pr-3 text-sm font-medium">
                {{ currency.label }}
              </SInputGroupText>
            </SInputGroupAddon>
          </SInputGroup>
        </div>
        <label
          class="flex w-fit items-center gap-2 text-sm text-muted-foreground"
        >
          <SCheckbox :model-value="true" disabled />
          <span>{{ $t("cashfloat.money-already-in-the-drawer") }}</span>
        </label>
        <SButton
          v-if="!showEditExistingAmountArea"
          type="button"
          variant="outline"
          size="lg"
          class="h-12 w-full"
          data-cy="edit-existing-amount-button"
          @click="toggleShowEditExistingAmount"
        >
          {{ $t("cashfloat.add-different-amount") }}
        </SButton>
        <div
          v-if="showEditExistingAmountArea"
          class="flex flex-col gap-5 border-t border-border pt-5"
        >
          <div>
            <p class="mb-1.5 text-[13px] font-medium text-muted-foreground">
              {{ t("cashfloat.manual-cashfloat") }}
            </p>
            <SInputGroup>
              <SInputGroupAddon align="inline-start">
                <SInputGroupText class="w-24 pl-3">{{
                  groupCurrency
                }}</SInputGroupText>
              </SInputGroupAddon>
              <SInputGroupInput
                class="h-[3.25rem] text-base"
                :model-value="totalByCurrency[groupCurrency]"
                @update:model-value="
                  (v) => (totalByCurrency[groupCurrency] = v)
                "
                @change="(e) => adjustAmount((e.target as HTMLInputElement).value, groupCurrency)"
                placeholder="Add total"
                type="number"
                :min="0"
                @focus="handleInputFocus"
                @blur="handleInputBlur"
                data-cy="cashfloat-amount-input"
              />
            </SInputGroup>
            <p class="mt-2 text-sm font-semibold">
              {{ t("cashfloat.difference") }}:
              {{
                cashfloatOpeningAmounts[groupCurrency] -
                (previousCashfloatAmounts[groupCurrency as Currencies] || 0)
              }}
              {{ groupCurrency }}
            </p>
          </div>
          <div
            v-for="(currencyLabel, index) in addedCurrencies"
            :key="currencyLabel"
          >
            <SInputGroup>
              <SInputGroupAddon align="inline-start" class="has-[>button]:ml-0">
                <SSelect
                  :model-value="addedCurrencies[index]"
                  @update:model-value="(v) => { addedCurrencies[index] = v as string; currencySelectChanged(v as string, currencyLabel); }"
                >
                  <SSelectTrigger
                    class="h-[3.25rem] w-24 rounded-none border-0 bg-transparent text-base shadow-none focus:ring-0 focus-visible:ring-0"
                  >
                    <SSelectValue />
                  </SSelectTrigger>
                  <SSelectContent>
                    <SSelectItem :value="currencyLabel">{{
                      currencyLabel
                    }}</SSelectItem>
                    <SSelectItem
                      v-for="item in notAddedCurrencies"
                      :key="item.id"
                      :value="item.label"
                    >
                      {{ item.label }}
                    </SSelectItem>
                  </SSelectContent>
                </SSelect>
              </SInputGroupAddon>
              <SInputGroupInput
                class="h-[3.25rem] text-base"
                :model-value="totalByCurrency[currencyLabel]"
                @update:model-value="
                  (v) => (totalByCurrency[currencyLabel] = v)
                "
                @change="(e) => adjustAmount((e.target as HTMLInputElement).value, currencyLabel)"
                placeholder="Add total"
                type="number"
                :min="0"
                @focus="handleInputFocus"
                @blur="handleInputBlur"
                data-cy="cashfloat-amount-input"
              />
              <SInputGroupAddon align="inline-end">
                <button
                  @click="removeAddedCurrency(currencyLabel)"
                  class="remove-currency-btn"
                >
                  X
                </button>
              </SInputGroupAddon>
            </SInputGroup>
            <p class="mt-2 text-sm font-semibold">
              {{ t("cashfloat.difference") }}:
              {{
                cashfloatOpeningAmounts[currencyLabel] -
                (previousCashfloatAmounts[currencyLabel as Currencies] || 0)
              }}
              {{ currencyLabel }}
            </p>
          </div>

          <div>
            <p class="mb-1.5 text-[13px] font-medium text-muted-foreground">
              {{
                t(
                  "cashfloat.manual-amount-differes-from-initial-amount-please-enter-note"
                )
              }}
            </p>
            <SInputGroup>
              <SInputGroupTextarea
                data-cy="cash-difference-note-input"
                :model-value="cashDifferenceNote"
                @update:model-value="(v) => (cashDifferenceNote = v)"
                :rows="3"
                :placeholder="t('cashfloat.write-your-note-here')"
              />
            </SInputGroup>
          </div>
        </div>
      </div>
      <div class="cashfloat-actions">
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="h-16 w-full text-base"
          :disabled="submitingCashFloat"
          data-cy="cancel-button"
          @click="cancel"
        >
          {{ $t("button.cancel") }}
        </SButton>
        <SButton
          type="button"
          size="lg"
          class="h-16 w-full text-base"
          :loading="submitingCashFloat"
          data-cy="confirm-button"
          @click="submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer"
        >
          {{ $t("button.confirm") }}
        </SButton>
      </div>
    </div>
    <!-- :: -->

    <div
      v-if="isDetailedCashfloat"
      style="
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-self: center;
        width: 50%;
        margin-top: 2%;
      "
    >
      <div style="text-align: center; margin-bottom: 3%; font-size: 30px">
        <p>
          <strong>{{ t("cashfloat.detailed") }}</strong>
        </p>
      </div>

      <div
        v-if="hasLocation"
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 1%;
        "
      >
        <div style="text-align: center; margin-right: 10px">
          <p>Cash taken from:</p>
        </div>
        <div>
          <SSelect v-model="locationId">
            <SSelectTrigger
              class="w-full"
              :disabled="isMoneyAlreadyInDrawer"
              data-cy="location-select"
            >
              <SSelectValue :placeholder="$t('location')" />
            </SSelectTrigger>
            <SSelectContent>
              <SSelectItem
                v-for="item in locationsList"
                :key="Number(item.id)"
                :value="Number(item.id)"
                data-cy="location-option"
              >
                {{ String(item.name) }}
              </SSelectItem>
            </SSelectContent>
          </SSelect>
        </div>
      </div>
      <div
        style="display: flex; flex-direction: row; justify-content: flex-end"
        v-if="hasLocation"
      >
        <label class="flex items-center gap-2">
          <SCheckbox
            :model-value="isMoneyAlreadyInDrawer"
            @update:model-value="
              (v) => {
                isMoneyAlreadyInDrawer = Boolean(v);
                resetLocationId();
              }
            "
            :disabled="!hasPreviousCashfloatMoney"
          />
          <span>Money already in the drawer</span>
        </label>
      </div>
      <div
        style="
          height: 54vh;
          border-radius: 6px;
          border: 1px solid #a6a6a6;
          padding: 4%;
        "
        ref="cashDetailsArea"
      >
        <div
          style="overflow-y: scroll; height: 45vh"
          v-if="detailedGroupCurrency"
        >
          <div
            v-for="(curr, index) in [
              detailedGroupCurrency,
              ...addedDetailedCurrencies,
            ]"
            :key="curr.id"
            :data-cy="`detailed-cashfloat-currency-${curr.label}`"
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  gap: 1rem;
                "
              >
                <SSelect
                  v-if="curr.label !== groupCurrency"
                  @update:model-value="(v) => currencySelectChangedCoinsAndBills(v as string, curr.label, index - 1)"
                >
                  <SSelectTrigger
                    class="border-0 bg-transparent text-[35px] p-0 shadow-none focus:ring-0 focus:ring-offset-0 mt-6 h-auto text-black"
                  >
                    <SSelectValue
                      :placeholder="
                        addedDetailedCurrencies[index - 1].detailedName
                      "
                    />
                  </SSelectTrigger>
                  <SSelectContent>
                    <SSelectItem
                      v-for="item in notAddedCurrenciesCoinsAndBills"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.detailedName }}
                    </SSelectItem>
                  </SSelectContent>
                </SSelect>
                <p v-else style="font-size: 35px">{{ curr.detailedName }}</p>
              </div>

              <SButton
                v-if="curr.label !== groupCurrency"
                type="button"
                variant="destructive"
                @click="removeAddedCurrencyCoinsAndBills(curr.label)"
              >
                Remove
              </SButton>
            </div>
            <div
              style="
                margin-top: 2%;
                margin-bottom: 2%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  border-bottom: 2px solid #ededed;
                  color: #a6a6a6;
                "
              >
                <div style="width: 20%; text-align: left">
                  <p>{{ t("cashfloat.bills") }}</p>
                </div>
                <div style="width: 20%; text-align: left">
                  <p>{{ t("cashfloat.amount") }}</p>
                </div>
                <div style="width: 58%; text-align: right">
                  <p>{{ t("cashfloat.value") }}</p>
                </div>
              </div>
              <div
                v-for="bill in curr.bills"
                :key="bill"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  border-bottom: 1px solid #ededed;
                  padding-bottom: 1%;
                  padding-top: 1%;
                "
              >
                <div style="width: 20%; text-align: left">
                  <p>
                    <strong>{{ bill.name }}</strong>
                  </p>
                </div>
                <div style="width: 20%; text-align: left">
                  <SInput
                    class="h-[3.25rem] text-base"
                    :model-value="bill.userInput"
                    @update:model-value="(v) => (bill.userInput = v)"
                    type="number"
                    :min="0"
                    @focus="handleInputFocus"
                    @blur="handleInputBlur"
                  />
                </div>
                <div style="width: 58%; text-align: right">
                  <p>
                    <strong>
                      {{
                        curr.symbol +
                        " " +
                        (
                          Number(bill.name) *
                          (bill.userInput ? bill.userInput : 0)
                        )
                          .toLocaleString("en-EN", {
                            /*style: "currency",
                            currency: "en-EN",*/
                            minimumFractionDigits: 2,
                            /*minimumIntegerDigits: 3,*/
                            maximumFractionDigits: 2,
                          })
                          .split(",")
                          .join("'")
                      }}
                    </strong>
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <div
              style="
                margin-top: 3%;
                margin-bottom: 2%;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  border-bottom: 2px solid #ededed;
                  color: #a6a6a6;
                "
              >
                <div style="width: 20%; text-align: left">
                  <p>{{ t("cashfloat.coins") }}</p>
                </div>
                <div style="width: 20%; text-align: left">
                  <p>{{ t("cashfloat.amount") }}</p>
                </div>
                <div style="width: 58%; text-align: right">
                  <p>{{ t("cashfloat.value") }}</p>
                </div>
              </div>
              <div
                v-for="coin in curr.coins"
                :key="coin"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  border-bottom: 1px solid #ededed;
                  padding-bottom: 1%;
                  padding-top: 1%;
                "
              >
                <div style="width: 20%; text-align: left">
                  <p>
                    <strong>{{ coin.name }}</strong>
                  </p>
                </div>
                <div style="width: 20%; text-align: left">
                  <SInput
                    class="h-[3.25rem] text-base"
                    :model-value="coin.userInput"
                    @update:model-value="(v) => (coin.userInput = v)"
                    type="number"
                    :min="0"
                    @focus="handleInputFocus"
                    @blur="handleInputBlur"
                  />
                </div>
                <div style="width: 58%; text-align: right">
                  <p>
                    <strong>{{
                      curr.symbol +
                      " " +
                      (
                        Number(coin.name) *
                        (coin.userInput ? coin.userInput : 0)
                      ) /*.toFixed(2)*/
                        .toLocaleString("en-EN", {
                          /*style: "currency",
                          currency: "en-EN",*/
                          minimumFractionDigits: 2,
                          /*minimumIntegerDigits: 3,*/
                          maximumFractionDigits: 2,
                        })
                        .split(",")
                        .join("'")
                    }}</strong>
                  </p>
                </div>
              </div>
              <div
                v-for="cent in curr.cents"
                :key="cent"
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  border-bottom: 1px solid #ededed;
                  padding-bottom: 1%;
                  padding-top: 1%;
                "
              >
                <div style="width: 20%; text-align: left">
                  <p>
                    <strong
                      >{{ cent.name
                      }}<span
                        style="color: #ededed; margin-left: 5px"
                        :data-cy="`detailed-cents-label-${curr.label}`"
                      >
                        {{ getCentsLabel(curr.label) }}</span
                      ></strong
                    >
                  </p>
                </div>
                <div style="width: 20%; text-align: left">
                  <SInput
                    class="h-[3.25rem] text-base"
                    :model-value="cent.userInput"
                    @update:model-value="(v) => (cent.userInput = v)"
                    type="number"
                    :min="0"
                    @focus="handleInputFocus"
                    @blur="handleInputBlur"
                  />
                </div>
                <div style="width: 58%; text-align: right">
                  <p>
                    <strong>{{
                      curr.symbol +
                      " " +
                      (
                        (Number(cent.name) *
                          (cent.userInput ? cent.userInput : 0)) /
                        100
                      ) /*.toFixed(2)*/
                        .toLocaleString("en-EN", {
                          /*style: "currency",
                          currency: "en-EN",*/
                          minimumFractionDigits: 2,
                          /*minimumIntegerDigits: 3,*/
                          maximumFractionDigits: 2,
                        })
                        .split(",")
                        .join("'")
                    }}</strong>
                  </p>
                </div>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 0.5rem;
                  padding-right: 0.5rem;
                "
              >
                <div>
                  <p>
                    <strong
                      >{{ t("cashfloat.total-cashfloat-in") }}
                      {{ curr.label }}</strong
                    >
                  </p>
                </div>
                <div>
                  <p>
                    <strong
                      >{{ curr.symbol }}
                      {{
                        sumCashByCurrency(curr.id) /*.toFixed(2)*/
                          .toLocaleString("en-EN", {
                            /*style: "currency",
                            currency: "en-EN",*/
                            minimumFractionDigits: 2,
                            /*minimumIntegerDigits: 3,*/
                            maximumFractionDigits: 2,
                          })
                          .split(",")
                          .join("'")
                      }}</strong
                    >
                  </p>
                </div>
              </div>
            </div>

            <!-- <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding-top: 1.5%;
              padding-bottom: 2.5%;
              border:1px solid red
            "
          >
            <div>
              <p>
                <strong
                  >{{ t("cashfloat.total-cashfloat-in") }}
                  {{ curr.label }}</strong
                >
              </p>
            </div>
            <div>
              <p>
                <strong>{{ sumCashByCurrency(curr.id).toFixed(2) }}</strong>
              </p>
            </div>
          </div> -->
          </div>
          <SButton
            v-if="
              notAddedCurrenciesCoinsAndBills.length &&
              hasMultiCurrenciesEnabled
            "
            type="button"
            variant="outline"
            size="sm"
            class="my-4 w-[30%] ml-auto"
            @click="addCurrencyCoinsAndBills"
          >
            {{ $t("multicurrencies.add-currency") }}
          </SButton>
        </div>
      </div>
      <div
        style="
          display: flex;
          gap: 3rem;
          border-top: 1px solid gray;
          margin-top: 3%;
          padding-top: 1.5%;
        "
      >
        <SButton
          v-if="false"
          type="button"
          size="sm"
          data-cy="scroll-top-button"
          @click="scrollToTop"
        >
          Scroll Top
        </SButton>
        <SButton
          type="button"
          variant="outline"
          size="lg"
          class="flex-1 min-w-0 h-16 text-base"
          :disabled="submitingCashFloat"
          data-cy="cancel-button"
          @click="cancel"
        >
          {{ $t("button.cancel") }}
        </SButton>
        <SButton
          v-if="canConfirmDetailedCashfloat"
          type="button"
          size="lg"
          class="flex-1 min-w-0 h-16 text-base"
          :loading="submitingCashFloat"
          data-cy="confirm-button"
          @click="submitDetailedCashfloat"
        >
          {{ $t("button.confirm") }}
        </SButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, nextTick } from "vue";
import {
  SButton,
  SInput,
  SInputGroup,
  SInputGroupAddon,
  SInputGroupInput,
  SInputGroupText,
  SInputGroupTextarea,
  SSelect,
  SSelectTrigger,
  SSelectValue,
  SSelectContent,
  SSelectItem,
  SCheckbox,
} from "@smeetz/ui-core";
import { ModalComponents } from "@/constants/modal";
import { useI18n } from "vue-i18n";
import { LogLevel, LogService } from "@/services/logging";
import dayjs from "dayjs";
import {
  CashAmounts,
  ICashFloat,
  ICashSummary,
  ICashTransfer,
} from "@/interfaces/cash-float/cash-float";
import { generateReadableId } from "@/utils/helpers/app";
import UserModule from "@/store/modules/user";
import POSConfigModule from "@/store/modules/pos-config";
import {
  Currencies,
  Currency,
  allDetailedCurrencies,
  detailedCurrency,
} from "@/constants/currency";
import DeviceModule from "@/store/modules/device";
import CashFloatModule from "@/store/modules/cash-float";
import { ensureSelectedOrder } from "@/utils/vue-helpers/orders.helper";
import { piniaStoreReady } from "@/utils/helpers/pinia.helper";
import randomstring from "randomstring";
import { getLastCashFloat } from "@/api/gql/device";
import {
  handleCashTransferSync,
  hasMultiCurrenciesEnabled,
} from "@/utils/vue-helpers/cash-float";
import { getCentsLabel } from "@/utils/vue-helpers/accounting";
import {
  areObjectsEqual,
  convertToCents,
  roundToNearestMultipleOf5,
} from "@/utils/helpers/common";
import { queryProductCategoriesByTicketGroup } from "@/dexie/product-category";
import { IProductCategory, PCTypes } from "@/types/db/product-category";
import {
  fetchAllPCsTimeslotsByDate,
  getTimeslotsByDate,
} from "@/utils/helpers/timeslots";

import { loadOffers } from "@/utils/helpers/offers";
import { syncDeviceLocation, syncGroupLocations } from "@/utils/helpers/device";
import { pushSyncCashfloat } from "@/api/cash-float/cash-float";
import NotificationService from "@/services/notification.service";
import { MoneyInOutType } from "@smeetz/compliance-common";
import {
  mapCashLocation,
  processMoneyInOutEvent,
} from "@/utils/helpers/compliance";
import { PaymentMethod } from "@smeetz/order-common";

enum CashfloatType {
  Detailed = "Detailed",
  General = "General",
}

export default defineComponent({
  name: ModalComponents.NewCashFloatOpen,
  components: {
    SButton,
    SInput,
    SInputGroup,
    SInputGroupAddon,
    SInputGroupInput,
    SInputGroupText,
    SInputGroupTextarea,
    SSelect,
    SSelectTrigger,
    SSelectValue,
    SSelectContent,
    SSelectItem,
    SCheckbox,
  },
  setup() {
    const { t } = useI18n({});
    // Whether detailed or general
    const cashfloatType = ref("");

    const isMoneyAlreadyInDrawer = ref(false);

    const hasPreviousCashfloatMoney = ref(null);

    const showEditExistingAmountArea = ref(false);

    const cashDifferenceNote = ref(null);
    // used only if previous cashfloat wasn't cashed out and the money still exists in the drawer
    const previousCashfloatAmounts = computed(() => {
      const result: CashAmounts = {};
      for (const i in currencies.value) {
        const currency = currencies.value[i];
        result[currency.label] = result[currency.label] =
          (CashFloatModule.previousCashfloat?.closingAmounts[currency.label] ||
            0) / 100;
      }
      return result;
    });

    const cashDetailsArea = ref<HTMLDivElement | null>(null);

    const submitingCashFloat = ref(false);

    const currencies = computed(() => {
      if (hasMultiCurrenciesEnabled.value) {
        return POSConfigModule.groupCurrencies;
      }
      const groupCurrency = POSConfigModule.groupCurrencies.find(
        (currency) => currency.isDefault === 1
      );
      if (groupCurrency) {
        return [groupCurrency];
      }
      return [POSConfigModule.groupCurrencies[0]];
    });

    const groupCurrency = computed(() => {
      const currency = currencies.value.find((c) => c.isDefault === 1)!;
      return currency.label;
    });

    // We only show in UI the currencies used by the organizer
    const detailedCurrencies = computed(() => {
      return allDetailedCurrencies.filter((c: any) =>
        currencies.value.some((currency) => currency.label === c.label)
      );
    });
    const detailedGroupCurrency = ref(
      detailedCurrencies.value.find((currency) => {
        return currency.label === groupCurrency.value;
      })
    );
    const selectedDetailedCurrencies = computed(() => {
      return [detailedGroupCurrency.value, ...addedDetailedCurrencies.value];
    });

    // contain ids of added currencies selected with dropdown
    const addedCurrencies = ref<string[]>([]);
    // same for coins and bills
    const addedDetailedCurrencies = ref<detailedCurrency[]>([]);
    const userFirstName = computed(() => {
      return UserModule.getUser.firstName;
    });

    // this is an object whereas the keys are the values of label field in currencies variable
    const totalByCurrency: any = ref({});

    const notAddedCurrencies = computed(() => {
      return currencies.value.filter((currency) => {
        return (
          currency.label !== groupCurrency.value &&
          !addedCurrencies.value.includes(currency.label)
        );
      });
    });

    const notAddedCurrenciesCoinsAndBills = computed(() => {
      return detailedCurrencies.value.filter((currency) => {
        return (
          currency.label !== groupCurrency.value &&
          !addedDetailedCurrencies.value.find((c) => c.label === currency.label)
        );
      });
    });

    const isGeneralCashfloat = computed(() => {
      // we show general cashfloat if user clicked on general cashfloat btn or if previous cashfloat amount wasn't cashed out
      return (
        cashfloatType.value === CashfloatType.General ||
        hasPreviousCashfloatMoney.value
      );
    });

    const isDetailedCashfloat = computed(() => {
      return cashfloatType.value === CashfloatType.Detailed;
    });

    /** Whether all relevant currency amounts in general mode are zero (no cash to source) */
    const allGeneralAmountsAreZero = computed(() => {
      const keys = Object.keys(totalByCurrency.value);
      for (let i = 0; i < keys.length; i++) {
        if (
          keys[i] !== groupCurrency.value &&
          !addedCurrencies.value.includes(keys[i])
        ) {
          continue;
        }
        if (totalByCurrency.value[keys[i]] > 0) {
          return false;
        }
      }
      return true;
    });

    const canConfirmGeneralCashfloat = computed(() => {
      // we show confirm button if all currencies amounts are entered
      let hasAmount = true;
      const keys = Object.keys(totalByCurrency.value);
      for (let i = 0; i < keys.length; i++) {
        if (
          keys[i] !== groupCurrency.value &&
          !addedCurrencies.value.includes(keys[i])
        ) {
          continue;
        }
        if (
          !totalByCurrency.value[keys[i]] &&
          totalByCurrency.value[keys[i]] !== 0
        ) {
          hasAmount = false;
        }
      }
      if (hasAmount) {
        // user entered amount
        if (hasLocation.value) {
          // user machine is linked
          if (
            isMoneyAlreadyInDrawer.value ||
            locationId.value ||
            allGeneralAmountsAreZero.value
          ) {
            // user action for money source is done
            return true;
          } else {
            // user action isn't done yet
            return false;
          }
        } else {
          // user machine isn't linked
          return true;
        }
      } else {
        // No amount
        return false;
      }
    });

    const canConfirmDetailedCashfloat = computed(() => {
      let canConfirm = true;
      for (let i = 0; i < selectedDetailedCurrencies.value.length; i++) {
        const currency = selectedDetailedCurrencies.value[i];
        if (!currency || !sumCashByCurrency(currency.label)) {
          canConfirm = false;
          break;
        }
      }
      // return (
      //   cashOpeningSum && (isMoneyAlreadyInDrawer.value || locationId.value)
      // );
      if (canConfirm) {
        // user entered amount
        if (hasLocation.value) {
          // user machine is linked
          if (isMoneyAlreadyInDrawer.value || locationId.value) {
            // user action for money source is done
            return true;
          } else {
            // user action isn't done yet
            return false;
          }
        } else {
          // user machine isn't linked
          return true;
        }
      } else {
        // No amount
        return false;
      }
    });

    // TODO HAMZA MULTIPLE CURRENCIES SUPPORT: no need for this when we start supporting multiple currencies
    const cashfloatOpeningAmounts = computed(() => {
      return totalByCurrency.value;
    });

    // TODO HAMZA LOCATIONS WORK: the below is only for testing. We need to have a better design for locations logic
    // await DeviceModule.fetchLocations();
    // locations shown to the user to choose from to becash out of this location
    const locationsList = computed(() => {
      return DeviceModule.locations.filter(
        (l) => l.id !== Number(DeviceModule.hardwareLocation?.locationId)
      );
    });
    // this the selected location
    const locationId = ref(
      /*
      locationsList.value && locationsList.value.length
        ? locationsList.value[0].id
        : null*/ null
    );

    const hasLocation = computed(() => {
      // If there is no hardware location (machine not linked to a location or user using a browser) we don't show device settings
      if (DeviceModule.hardwareLocation) {
        return true;
      } else {
        return false;
      }
    });

    function adjustAmount(val: string, currencyLabel: string) {
      if (currencyLabel === Currencies.CHF) {
        const intValue = Number(val);
        if (intValue) {
          const valueInCents = convertToCents(intValue);
          const finalValue = roundToNearestMultipleOf5(valueInCents) / 100;
          totalByCurrency.value[currencyLabel] = finalValue;
        }
      }
    }

    // reset total by currency in case user changes dropdown value after filling input
    function currencySelectChanged(
      newCurrencyLabel: string,
      oldCurrencyLabel: string
    ) {
      if (newCurrencyLabel !== oldCurrencyLabel) {
        totalByCurrency.value[oldCurrencyLabel] = 0;
      }
    }
    function currencySelectChangedCoinsAndBills(
      newCurrencyLabel: string,
      oldCurrencyLabel: string,
      index: number
    ) {
      if (newCurrencyLabel !== oldCurrencyLabel) {
        const detailedCurrencyToAdd = detailedCurrencies.value.find(
          (currency) => {
            return currency.label === newCurrencyLabel;
          }
        );
        if (detailedCurrencyToAdd) {
          addedDetailedCurrencies.value[index] = detailedCurrencyToAdd;
        }
      }
    }

    function toggleCashfloatType(type: string) {
      cashfloatType.value = type;
      LogService.info(`User chose ${type} cashfloat`);
    }

    function sumCashByCurrency(currencyId: string) {
      const currency = selectedDetailedCurrencies.value.find(
        (c: any) => c.label === currencyId
      );
      if (currency) {
        let sum = 0;
        for (let i = 0; i < currency.bills.length; i++) {
          sum =
            sum +
            Number(currency.bills[i].name) *
              Number(currency.bills[i].userInput);
        }

        for (let i = 0; i < currency.coins.length; i++) {
          sum =
            sum +
            Number(currency.coins[i].name) *
              Number(currency.coins[i].userInput);
        }

        for (let i = 0; i < currency.cents.length; i++) {
          sum =
            sum +
            (Number(currency.cents[i].name) *
              Number(currency.cents[i].userInput)) /
              100;
        }
        return sum;
      }
      return 0;
    }

    function scrollToTop() {
      cashDetailsArea.value?.scrollTo({
        // top: cashDetailsArea.value?.scrollHeight,
        top: 0,
        behavior: "smooth",
      });
    }

    function scrollTo(position: number) {
      cashDetailsArea.value?.scrollTo({
        top: position,
        behavior: "smooth",
      });
    }

    function resetLocationId() {
      locationId.value = null;
    }

    function toggleShowEditExistingAmount() {
      showEditExistingAmountArea.value = !showEditExistingAmountArea.value;
    }

    function addCurrency() {
      for (const element of currencies.value) {
        if (
          element.label !== groupCurrency.value &&
          !addedCurrencies.value.includes(element.label)
        ) {
          addedCurrencies.value.push(element.label);
          // Initialize amount so the confirm button logic sees 0 instead of undefined
          if (typeof totalByCurrency.value[element.label] === "undefined") {
            totalByCurrency.value[element.label] = 0;
          }
          return;
        }
      }
    }
    function addCurrencyCoinsAndBills() {
      for (const element of detailedCurrencies.value) {
        if (
          element.label !== groupCurrency.value &&
          !addedDetailedCurrencies.value.find((c) => c.label === element.label)
        ) {
          addedDetailedCurrencies.value.push(element);
          return;
        }
      }
    }

    function removeAddedCurrency(currencyToRemove: string) {
      if (totalByCurrency.value[currencyToRemove]) {
        totalByCurrency.value[currencyToRemove] = 0;
      }
      addedCurrencies.value = addedCurrencies.value.filter(
        (currency) => currency !== currencyToRemove
      );
    }
    function removeAddedCurrencyCoinsAndBills(currencyToRemove: string) {
      addedDetailedCurrencies.value = addedDetailedCurrencies.value.filter(
        (detailedCurrency) => detailedCurrency.label !== currencyToRemove
      );
    }

    async function submitDetailedCashfloat() {
      submitingCashFloat.value = true;
      let isPayInEventProcessed = false;
      LogService.info(
        `Sale opening: User clicked to create a detailed cashfloat`
      );
      const groupId = POSConfigModule.groupId || UserModule.getUserGroupId;

      const firstCurrency = detailedGroupCurrency.value;
      if (!firstCurrency) {
        LogService.info(
          `Sale opening: Aborting submiting detailed cash float, no group currency set `,
          {
            params: {
              detailedCurrencies: detailedCurrencies.value,
              groupCurrency: groupCurrency.value,
            },
          }
        );
        return;
      }
      const cashOpeningSum = sumCashByCurrency(firstCurrency.label);

      // We only do cash movement if user entered money and selected its source
      if (hasLocation.value && cashOpeningSum && locationId.value) {
        // Add a new CashTransfer of type (IN)
        const cashTransferIn: ICashTransfer = {
          _id: randomstring.generate(10) + dayjs().toISOString(),
          createdAt: dayjs().toISOString(),
          amount: cashOpeningSum,
          currency: firstCurrency.label as Currencies, // For now backend only support one currency
          groupId: Number(groupId),
          from: locationId.value || null,
          to: Number(DeviceModule.hardwareLocation?.locationId) || null,
          note: "" /*form.message || null*/,
          channel: "Smeetz POS",
          uuid: randomstring.generate(10),
        };

        if (!CashFloatModule.initialTransferDone) {
          const isSynced = await handleCashTransferSync(cashTransferIn);
          if (!isSynced) {
            submitingCashFloat.value = false;
            return;
          }
        }

        // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
        CashFloatModule.setInitialTransferDone(true);

        // lets reset transferAmount
        CashFloatModule.setTransfersAmount(0);
        CashFloatModule.setSumOfCashIn(0);
        CashFloatModule.setSumOfCashOut(0);

        // process money in/out event after cash transfer
        try {
          const eventData = {
            moneyInOutType: MoneyInOutType.PAY_IN,
            amount: Number(cashfloatOpeningAmounts.value[groupCurrency.value]),
            description: "Cash transfer IN to open sales",
            posDateTime: dayjs().toISOString(),
            paymentType: PaymentMethod.CASH,
            cashLocation: mapCashLocation(locationId.value),
          };
          await processMoneyInOutEvent(eventData);
          isPayInEventProcessed = true;
        } catch (error) {
          LogService.info("Failed process money in/out event", { error });
        }
      }

      // Lets now build the cashfloat object
      let message = "";
      // let's get the seqId of the last cashfloat
      let lastSeqId = 0;
      try {
        const last = await getLastCashFloat(DeviceModule.newLogicDeviceId);
        lastSeqId = Number(last.SeqId);
      } catch (error) {
        message = "Couldn't get last seq_id from backend";
      }

      const dateNow = dayjs().toISOString();
      const uid = generateReadableId();
      const valuesForBackend: CashAmounts = {};
      detailedCurrencies.value.forEach((currency: any) => {
        valuesForBackend[currency.label as Currencies] = convertToCents(
          sumCashByCurrency(currency.label)
        );
      });
      const cashFloat: ICashFloat = {
        seqId: lastSeqId + 1,
        userId: UserModule.userId,
        posId: null,
        groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
        firstPosConfigId: POSConfigModule.selectedConfig
          ? POSConfigModule.selectedConfig.id
          : null,
        startAmounts: valuesForBackend,
        amounts: valuesForBackend,
        userSwitch: [],
        closeDate: "",
        createdAt: dateNow,
        updatedAt: dateNow,
        uid: uid,
        deviceId: DeviceModule.newLogicDeviceId,
        version: 1,
        message,
      };

      if (cashOpeningSum) {
        let billsAndCoins: ICashSummary[] = [];
        selectedDetailedCurrencies.value.forEach((currency: any) => {
          billsAndCoins.push({
            currency: currency.label,
            bills: currency.bills.map((b: any) => {
              return { name: b.name, userInput: b.userInput };
            }),
            coins: currency.coins.map((c: any) => {
              return { name: c.name, userInput: c.userInput };
            }),
            cents: currency.cents.map((c: any) => {
              return { name: c.name, userInput: c.userInput };
            }),
          });
        });

        cashFloat.billsAndCoinsByCurrency = { opening: billsAndCoins };
      }

      const maxRetries = 3;
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          LogService.info(
            `Sale opening: Submitting new cashfloat (attempt ${attempt}/${maxRetries}), uuid: ${cashFloat.uid}`,
            {
              cashfloat: cashFloat,
            }
          );
          await pushSyncCashfloat([cashFloat]);
          // Success - break out of retry loop
          break;
        } catch (error) {
          if (attempt === maxRetries) {
            // Final attempt failed
            LogService.info(
              `Sale opening: Error submitting new cashfloat after ${maxRetries} attempts, uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            NotificationService.showCustomMessage(
              t("error.open-sales"),
              "error"
            );
            submitingCashFloat.value = false;
            return;
          } else {
            // Log the attempt failure but continue retrying
            LogService.info(
              `Sale opening: Attempt ${attempt} failed, retrying... uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 1000)); // wait 1 second before retrying
          }
        }
      }

      // reset the flag
      CashFloatModule.setInitialTransferDone(false);

      LogService.info(`Setting a new cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });
      CashFloatModule.setCashFloat(cashFloat);

      // Ensure an order tab exists to have something on the UI. On the first
      // cashfloat of the app session the bootstrap (initPiniaStore) creates it
      // once the session data resolves; re-opening a till later in the same
      // session must create it here. nextTick lets the session data pick up
      // the new cashfloat before the order is created.
      await nextTick();
      await piniaStoreReady;
      await ensureSelectedOrder();
      LogService.info(`Created cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });

      // Now lets log current memory consumption
      logMemoryConsumption();

      // ModalModule.setStatus(ModalStatus.Hidden);
      CashFloatModule.setIsOpeningCashfloat(false);

      // fetch timeslots in case they did not exist in indexedDB
      loadTodaysTimeSlotsIfNone();

      // pull available offers
      try {
        await loadOffers();
        LogService.info("Offers object instantiated");
      } catch (error) {
        LogService.info("Failed to instantiate offers object", { error });
      }

      // process money in/out event
      // No need to reprocess if we already did it after cash transfer
      if (!isPayInEventProcessed) {
        try {
          const eventData = {
            moneyInOutType: MoneyInOutType.OPENING_BALANCE,
            amount:
              (valuesForBackend[groupCurrency.value as Currencies] || 0) / 100,
            description: "Opening balance with money already in drawer",
            posDateTime: dayjs().toISOString(),
            paymentType: PaymentMethod.CASH,
            cashLocation: mapCashLocation(locationId.value),
          };
          await processMoneyInOutEvent(eventData);
        } catch (error) {
          LogService.info("Failed process money in/out event", { error });
        }
      }

      submitingCashFloat.value = false;
    }
    async function submitGeneralCashfloat() {
      submitingCashFloat.value = true;
      let isPayInEventProcessed = false;
      LogService.info(
        `Sale opening: User clicked to create a general cashfloat`
      );
      const groupId = POSConfigModule.groupId || UserModule.getUserGroupId;

      // We only do cash movement if user entered money and selected its source
      const firstCurrency = detailedGroupCurrency.value;
      if (!firstCurrency) {
        LogService.info(
          `Sale opening: Aborting submiting general cash float, no group currency set `,
          {
            params: {
              detailedCurrencies: detailedCurrencies.value,
              groupCurrency: groupCurrency.value,
            },
          }
        );
        return;
      }
      let openingAmountsValid = true;
      if (isNaN(Number(cashfloatOpeningAmounts.value[firstCurrency.label]))) {
        openingAmountsValid = false;
      }
      if (hasLocation.value && openingAmountsValid && locationId.value) {
        // Add a new CashTransfer of type (IN)
        const cashTransferIn: ICashTransfer = {
          _id: dayjs().toISOString(),
          createdAt: dayjs().toISOString(),
          amount: Number(cashfloatOpeningAmounts.value[firstCurrency.label]),
          currency: firstCurrency.label as Currencies,
          groupId: Number(groupId),
          from: locationId.value || null,
          to: Number(DeviceModule.hardwareLocation?.locationId) || null,
          note: "" /*form.message || null*/,
          channel: "Smeetz POS",
          uuid: randomstring.generate(10),
        };
        LogService.info("Inserting cashTranser to indexedDB (attached)", {
          params: cashTransferIn,
        });

        if (!CashFloatModule.initialTransferDone) {
          const isSynced = await handleCashTransferSync(cashTransferIn);
          if (!isSynced) {
            submitingCashFloat.value = false;
            return;
          }

          // process money in/out event after cash transfer
          try {
            const eventData = {
              moneyInOutType: MoneyInOutType.PAY_IN,
              amount: Number(
                cashfloatOpeningAmounts.value[groupCurrency.value]
              ),
              description: "Cash transfer IN to open sales",
              posDateTime: dayjs().toISOString(),
              paymentType: PaymentMethod.CASH,
              cashLocation: mapCashLocation(locationId.value),
            };
            await processMoneyInOutEvent(eventData);
            isPayInEventProcessed = true;
          } catch (error) {
            LogService.info("Failed process money in/out event", { error });
          }
        }

        // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
        CashFloatModule.setInitialTransferDone(true);

        // lets reset transferAmount
        CashFloatModule.setTransfersAmount(0);
        CashFloatModule.setSumOfCashIn(0);
        CashFloatModule.setSumOfCashOut(0);
      }

      let message = "";
      // let's get the seqId of the last cashfloat
      let lastSeqId = 0;
      try {
        const last = await getLastCashFloat(DeviceModule.newLogicDeviceId);
        lastSeqId = Number(last.SeqId);
      } catch (error) {
        message = "Couldn't get last seq_id from backend";
      }

      const dateNow = dayjs().toISOString();
      const uid = generateReadableId();
      let cashfloatOpeningAmountsForBackend: CashAmounts = {};
      for (const key in cashfloatOpeningAmounts.value) {
        cashfloatOpeningAmountsForBackend[key as Currencies] = convertToCents(
          Number(cashfloatOpeningAmounts.value[key])
        );
      }
      const cashFloat: ICashFloat = {
        seqId: lastSeqId + 1,
        userId: UserModule.userId,
        posId: null,
        groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
        firstPosConfigId: POSConfigModule.selectedConfig
          ? POSConfigModule.selectedConfig.id
          : null,
        startAmounts: cashfloatOpeningAmountsForBackend,
        amounts: cashfloatOpeningAmountsForBackend,
        userSwitch: [],
        closeDate: "",
        createdAt: dateNow,
        updatedAt: dateNow,
        uid: uid,
        deviceId: DeviceModule.newLogicDeviceId,
        version: 1,
        billsAndCoinsByCurrency: {},
        message,
      };

      const maxRetries = 3;
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          LogService.info(
            `Sale opening: Submitting new cashfloat (attempt ${attempt}/${maxRetries}), uuid: ${cashFloat.uid}`,
            {
              cashfloat: cashFloat,
            }
          );
          await pushSyncCashfloat([cashFloat]);
          // Success - break out of retry loop
          break;
        } catch (error) {
          if (attempt === maxRetries) {
            // Final attempt failed
            LogService.info(
              `Sale opening: Error submitting new cashfloat after ${maxRetries} attempts, uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            NotificationService.showCustomMessage(
              t("error.open-sales"),
              "error"
            );
            submitingCashFloat.value = false;
            return;
          } else {
            // Log the attempt failure but continue retrying
            LogService.info(
              `Sale opening: Attempt ${attempt} failed, retrying... uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 1000)); // wait 1 second before retrying
          }
        }
      }

      // reset the flag
      CashFloatModule.setInitialTransferDone(false);

      LogService.info(`Setting a new cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });
      CashFloatModule.setCashFloat(cashFloat);

      // Ensure an order tab exists to have something on the UI. On the first
      // cashfloat of the app session the bootstrap (initPiniaStore) creates it
      // once the session data resolves; re-opening a till later in the same
      // session must create it here. nextTick lets the session data pick up
      // the new cashfloat before the order is created.
      await nextTick();
      await piniaStoreReady;
      await ensureSelectedOrder();
      LogService.info(`Created cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });

      // Now lets log current memory consumption
      logMemoryConsumption();

      // ModalModule.setStatus(ModalStatus.Hidden);
      CashFloatModule.setIsOpeningCashfloat(false);

      // fetch timeslots in case they did not exist in indexedDB
      loadTodaysTimeSlotsIfNone();

      // pull available offers
      try {
        await loadOffers();
        LogService.info("Offers object instantiated");
      } catch (error) {
        LogService.info("Failed to instantiate offers object", { error });
      }

      // process money in/out event
      // No need to reprocess if we already did it after cash transfer
      if (!isPayInEventProcessed) {
        try {
          const eventData = {
            moneyInOutType: MoneyInOutType.OPENING_BALANCE,
            amount: Number(cashfloatOpeningAmounts.value[groupCurrency.value]),
            description: "Opening balance",
            posDateTime: dayjs().toISOString(),
            paymentType: PaymentMethod.CASH,
            cashLocation: mapCashLocation(locationId.value),
          };
          await processMoneyInOutEvent(eventData);
        } catch (error) {
          LogService.info("Failed process money in/out event", { error });
        }
      }

      submitingCashFloat.value = false;
    }
    async function submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer() {
      // This is the case where the user had money in the drawer already
      // If user confirmed the amount that already exist in the drawer then we'll do a cashfloat synch only
      // If user entered a manual amount, then we`ll first do cash transfer with isGainLoss to justify the difference
      // then we synch the cashfloat
      submitingCashFloat.value = true;
      LogService.info(
        `Sale opening: Creating a cashfloat with an existing money from previous cashfloat`
      );

      if (
        !cashfloatOpeningAmounts.value ||
        areObjectsEqual(
          cashfloatOpeningAmounts.value,
          previousCashfloatAmounts.value
        )
      ) {
        // user didn't edit the amount of the previous cashfloat OR user entered exactly the same amount
        // do nothing here, we will just synch the cashfloat
      } else {
        // so user did change the amount of the previous cashfloat
        // we will do a cash transfer to justify where the extra money came from or where the missing money went

        ////
        LogService.info(
          `When Opening cashfloat, user entered manual amount different than previous cashfloat amount`,
          {
            params: {
              previousCashfloatAmounts: previousCashfloatAmounts.value,
              manualOpeningAmounts: cashfloatOpeningAmounts.value,
            },
          }
        );

        const groupId = POSConfigModule.groupId || UserModule.getUserGroupId;
        // For now backend only support one currency
        const firstCurrency = detailedGroupCurrency.value;
        if (!firstCurrency) {
          LogService.info(
            `Sale opening: Aborting submiting general cash float, no group currency set `,
            {
              params: {
                detailedCurrencies: detailedCurrencies.value,
                groupCurrency: groupCurrency.value,
              },
            }
          );
          return;
        }
        let from = null;
        let to = null;
        if (
          cashfloatOpeningAmounts.value[firstCurrency.label] >
          (previousCashfloatAmounts.value[firstCurrency.label as Currencies] ||
            0)
        ) {
          // gain
          to =
            DeviceModule.hardwareLocation &&
            DeviceModule.hardwareLocation?.locationId
              ? Number(DeviceModule.hardwareLocation?.locationId)
              : null;
          from = null;
        } else {
          // cashOut from the device because it is a loss
          from =
            DeviceModule.hardwareLocation &&
            DeviceModule.hardwareLocation?.locationId
              ? Number(DeviceModule.hardwareLocation?.locationId)
              : null;
          to = null;
        }
        const cashTransfer: ICashTransfer = {
          _id: dayjs().toISOString(),
          createdAt: dayjs().toISOString(),
          amount: Math.abs(
            Number(
              previousCashfloatAmounts.value[firstCurrency.label as Currencies]
            ) -
              Number(
                cashfloatOpeningAmounts.value[firstCurrency.label as Currencies]
              )
          ),
          currency: firstCurrency.label as Currencies,
          groupId: Number(groupId),
          from: from,
          to: to,
          note: cashDifferenceNote.value,
          channel: "Smeetz POS",
          uuid: randomstring.generate(10),
          isGainLoss: true,
        };
        if (!CashFloatModule.initialTransferDone) {
          const isSynced = await handleCashTransferSync(cashTransfer);
          if (!isSynced) {
            submitingCashFloat.value = false;
            return;
          }

          // process money in/out event after gain/loss cash transfer
          try {
            const previousAmount = Number(
              previousCashfloatAmounts.value[firstCurrency.label as Currencies]
            );
            const currentAmount = Number(
              cashfloatOpeningAmounts.value[firstCurrency.label as Currencies]
            );
            const gain = previousAmount - currentAmount < 0;
            const difference = currentAmount - previousAmount;
            const eventData = {
              moneyInOutType: MoneyInOutType.DIFFERENCE,
              amount: difference,
              description: (gain ? "GAIN" : "LOSS") + " cash transfer",
              posDateTime: dayjs().toISOString(),
              paymentType: PaymentMethod.CASH,
              cashLocation: mapCashLocation(null),
            };
            await processMoneyInOutEvent(eventData);
          } catch (error) {
            LogService.info("Failed process money in/out event", { error });
          }
        }

        // In case cashfloat sync fails, we set the flag to true to avoid multiple cash transfer insertions
        CashFloatModule.setInitialTransferDone(true);
      }

      // lets reset transferAmount
      LogService.info(
        `Sale opening: Setting cashIn and cashOut from previous session to 0`
      );
      CashFloatModule.setTransfersAmount(0);
      CashFloatModule.setSumOfCashIn(0);
      CashFloatModule.setSumOfCashOut(0);

      const dateNow = dayjs().toISOString();
      const uid = generateReadableId();
      let valuesForBackend: CashAmounts = {};
      for (const i in currencies.value) {
        const currency = currencies.value[i];
        if (cashfloatOpeningAmounts.value[currency.label]) {
          // so user entered amount
          // it could be the case where there were no money in the drawer
          // and it could be the case where there were money in the drawer but user edited it
          valuesForBackend[currency.label as Currencies] = convertToCents(
            cashfloatOpeningAmounts.value[currency.label]
          );
        } else if (
          previousCashfloatAmounts.value[currency.label as Currencies]
        ) {
          // so user didn't enter any amount but we have the drawer already having money in it
          // we will consider it as initial amount of the new cashfloat
          valuesForBackend[currency.label as Currencies] = convertToCents(
            previousCashfloatAmounts.value[currency.label as Currencies] || 0
          );
        } else {
          valuesForBackend[currency.label as Currencies] = 0;
        }
      }

      let message = "";
      // let's get the seqId of the last cashfloat
      let lastSeqId = 0;
      try {
        const last = await getLastCashFloat(DeviceModule.newLogicDeviceId);
        lastSeqId = Number(last.SeqId);
      } catch (error) {
        message = "Couldn't get last seq_id from backend";
      }

      const cashFloat: ICashFloat = {
        seqId: lastSeqId + 1,
        userId: UserModule.userId,
        posId: null,
        groupId: POSConfigModule.groupId || UserModule.getUserGroupId,
        firstPosConfigId: POSConfigModule.selectedConfig
          ? POSConfigModule.selectedConfig.id
          : null,
        startAmounts: valuesForBackend,
        amounts: valuesForBackend,
        userSwitch: [],
        closeDate: "",
        createdAt: dateNow,
        updatedAt: dateNow,
        uid: uid,
        deviceId: DeviceModule.newLogicDeviceId,
        version: 1,
        billsAndCoinsByCurrency: {},
        message,
      };

      const maxRetries = 3;
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          LogService.info(
            `Sale opening: Submitting new cashfloat (attempt ${attempt}/${maxRetries}), uuid: ${cashFloat.uid}`,
            {
              cashfloat: cashFloat,
            }
          );
          await pushSyncCashfloat([cashFloat]);
          // Success - break out of retry loop
          break;
        } catch (error) {
          if (attempt === maxRetries) {
            // Final attempt failed
            LogService.info(
              `Sale opening: Error submitting new cashfloat after ${maxRetries} attempts, uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            NotificationService.showCustomMessage(
              t("error.open-sales"),
              "error"
            );
            submitingCashFloat.value = false;
            return;
          } else {
            // Log the attempt failure but continue retrying
            LogService.info(
              `Sale opening: Attempt ${attempt} failed, retrying... uuid: ${cashFloat.uid}`,
              {
                cashfloat: cashFloat,
                error: error,
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 1000)); // wait 1 second before retrying
          }
        }
      }

      // reset the flag
      CashFloatModule.setInitialTransferDone(false);

      LogService.info(`Setting a new cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });
      CashFloatModule.setCashFloat(cashFloat);

      // Ensure an order tab exists to have something on the UI. On the first
      // cashfloat of the app session the bootstrap (initPiniaStore) creates it
      // once the session data resolves; re-opening a till later in the same
      // session must create it here. nextTick lets the session data pick up
      // the new cashfloat before the order is created.
      await nextTick();
      await piniaStoreReady;
      await ensureSelectedOrder();
      LogService.info(`Created cashfloat with uuid ${cashFloat.uid}`, {
        params: cashFloat,
      });

      // Now lets log current memory consumption
      logMemoryConsumption();

      // ModalModule.setStatus(ModalStatus.Hidden);
      CashFloatModule.setIsOpeningCashfloat(false);

      // fetch timeslots in case they did not exist in indexedDB
      loadTodaysTimeSlotsIfNone();

      // pull available offers
      try {
        await loadOffers();
        LogService.info("Offers object instantiated");
      } catch (error) {
        LogService.info("Failed to instantiate offers object", { error });
      }

      // process money in/out event
      try {
        const eventData = {
          moneyInOutType: MoneyInOutType.OPENING_BALANCE,
          amount:
            (valuesForBackend[groupCurrency.value as Currencies] || 0) / 100,
          description: "Opening balance with bills and coins",
          posDateTime: dayjs().toISOString(),
          paymentType: PaymentMethod.CASH,
          cashLocation: mapCashLocation(locationId.value),
        };
        await processMoneyInOutEvent(eventData);
      } catch (error) {
        LogService.info("Failed process money in/out event", { error });
      }

      submitingCashFloat.value = false;
    }

    function logMemoryConsumption() {
      try {
        if (window.performance && (window.performance as any).memory) {
          const memory = (window.performance as any).memory;
          const mem = {
            date: dayjs().utc().toISOString(),
            totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
            usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
            jsHeapSizeLimit: memory.jsHeapSizeLimit / (1024 * 1024),
            domMemory:
              (memory.totalJSHeapSize - memory.usedJSHeapSize) / (1024 * 1024),
          };
          LogService.info(`Memory consumption after starting sales`, {
            params: { memoryConsumption: mem },
          });
        }
      } catch (err) {
        // Couldn't log memory consumption
        LogService.info(
          `Error when trying to log memory consumption`,
          {
            params: { error: err },
          },
          LogLevel.Error
        );
      }
    }
    function handleInputFocus(event: any) {
      if (event.target.value === "0") {
        event.target.value = "";
      }
    }

    function handleInputBlur(event: any) {
      if (event.target.value === "") {
        event.target.value = "0";
      }
    }
    // checks if todays timeslots are present in indexedDB or not, if not it fetches them from backend
    // this is to handle the case where user do not logout overnight and end up not reloading their configs
    async function loadTodaysTimeSlotsIfNone() {
      const ticketGroups = POSConfigModule.getSelectedConfig?.ticketGroups;
      if (!ticketGroups?.length) {
        return;
      }
      const today = new Date(
        dayjs().toDate().toDateString() + " " + new Date().toTimeString()
      );
      for (let i = 0; i < ticketGroups.length; i++) {
        const ticketGroup = ticketGroups[i];
        const dayTimeSlots = await getTimeslotsByDate(today, ticketGroup);
        if (!dayTimeSlots?.length) {
          // Retrieve all the timeslots that belong to a group of products within a certain date
          let productCategories: IProductCategory[] | undefined =
            await queryProductCategoriesByTicketGroup({
              ticketGroupId: ticketGroup,
              excludeTypes: [PCTypes[PCTypes.Retail]],
            });
          productCategories =
            productCategories.length > 0 ? productCategories : undefined;
          let productCategoriesIds =
            productCategories?.map((pc) => {
              // if this is a seating plan then we consider the parent category id because the child category isn't linked to the timeslots
              if (
                pc.type === PCTypes[PCTypes.SeatedSub] &&
                pc.seatingParentPSCId
              )
                return pc.seatingParentPSCId;
              return pc.id;
            }) || [];
          // Fetch timeslots of today
          await fetchAllPCsTimeslotsByDate(
            productCategoriesIds,
            today.toISOString()
          );
        }
      }
    }
    return {
      t,
      getCentsLabel,
      cashfloatType,
      isGeneralCashfloat,
      isDetailedCashfloat,
      toggleCashfloatType,
      CashfloatType,
      currencies,
      detailedCurrencies,
      totalByCurrency,
      canConfirmGeneralCashfloat,
      allGeneralAmountsAreZero,
      canConfirmDetailedCashfloat,
      cashfloatOpeningAmounts,
      locationsList,
      locationId,
      sumCashByCurrency,
      scrollToTop,
      cashDetailsArea,
      scrollTo,
      userFirstName,
      hasLocation,
      isMoneyAlreadyInDrawer,
      resetLocationId,
      hasPreviousCashfloatMoney,
      previousCashfloatAmounts,
      showEditExistingAmountArea,
      toggleShowEditExistingAmount,
      cashDifferenceNote,
      addedCurrencies,
      groupCurrency,
      currencySelectChanged,
      addCurrency,
      notAddedCurrencies,
      removeAddedCurrency,
      addedDetailedCurrencies,
      notAddedCurrenciesCoinsAndBills,
      addCurrencyCoinsAndBills,
      removeAddedCurrencyCoinsAndBills,
      detailedGroupCurrency,
      currencySelectChangedCoinsAndBills,
      selectedDetailedCurrencies,
      submitDetailedCashfloat,
      submitGeneralCashfloat,
      submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer,
      hasMultiCurrenciesEnabled,
      adjustAmount,
      handleInputFocus,
      handleInputBlur,
      submitingCashFloat,
    };
  },
  async created() {
    LogService.info(`CashfloatOpen component created: Syncing device location`);
    // initialize all currency amounts to 0
    this.currencies.forEach((currency: Currency) => {
      if (typeof this.totalByCurrency[currency.label] === "undefined") {
        this.totalByCurrency[currency.label] = 0;
      }
    });
    // Skip the cashfloat type choice screen
    // if there's a previous cashfloat (restored from localStorage)
    const previousCashfloatInfo = CashFloatModule.getPreviousCashfloat;
    if (previousCashfloatInfo && !previousCashfloatInfo.isCashedOut) {
      // user didn't cash out previous cashfloat
      this.hasPreviousCashfloatMoney = true;
      // set currency amounts to match previous uncashed cashfloat
      for (const curr in previousCashfloatInfo.closingAmounts) {
        const currency = curr as Currencies;
        if (
          typeof previousCashfloatInfo.closingAmounts[currency] !== undefined
        ) {
          // divide by 100, since closingAmounts is in cents
          this.totalByCurrency[currency] =
            (previousCashfloatInfo.closingAmounts[currency] || 0) / 100;
        }
      }
    }
    // Refresh device/location data (locations list, hardware location)
    await syncGroupLocations();
    await syncDeviceLocation();
  },
  mounted() {
    // lets reset transferAmount
    LogService.info(
      `CashfloatOpen component mounted: Setting cashIn and cashOut from previous session to 0`
    );
    CashFloatModule.setTransfersAmount(0);
    CashFloatModule.setSumOfCashIn(0);
    CashFloatModule.setSumOfCashOut(0);

    // Logging payment settings
    LogService.info(`Payment settings of the user: `, {
      params: POSConfigModule.getPaymentSettings,
    });
  },
  methods: {
    cancel() {
      // ModalModule.setStatus(ModalStatus.Hidden);
      CashFloatModule.setIsOpeningCashfloat(false);
    },
  },
});
</script>
<style lang="scss">
@use "@/styles/variables.scss" as *;
.new-cash-float-open {
  padding-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  scrollbar-gutter: stable;

  .cashfloat-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 3rem;
    gap: 3rem;
  }
  .remove-currency-btn {
    width: 1.5rem;
    height: 1.5rem;
    align-self: center;

    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .remove-currency-btn:hover {
    background-color: #e15241;
    color: white;
  }
}
</style>
